import React from 'react';
import Icon from '@/components/ui/AppIcon';

export default function AdminHeader() {
  return (
    <div className="flex items-center justify-between">
      <div>
        <div className="flex items-center gap-3 mb-1">
          <h1 className="text-2xl font-700 text-foreground">Admin Panel</h1>
          <span className="bg-negative/15 border border-negative/30 text-negative text-xs font-700 px-2.5 py-1 rounded-full">
            Admin Access
          </span>
        </div>
        <p className="text-sm text-muted-foreground">
          360 Creator Platform · 18 août 2026 · 19:36
        </p>
      </div>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 bg-warning/10 border border-warning/20 rounded-lg px-3 py-2">
          <Icon name="ExclamationTriangleIcon" size={14} className="text-warning" />
          <span className="text-xs font-600 text-warning">7 vérifications en attente</span>
        </div>
        <button className="flex items-center gap-2 bg-primary hover:bg-primary/90 text-primary-foreground text-sm font-600 px-4 py-2 rounded-lg transition-all active:scale-95">
          <Icon name="PlusIcon" size={16} />
          Ajouter créateur
        </button>
      </div>
    </div>
  );
}